import axios from "axios";
import {WeightUnit} from "../../models";
import {CalculatorC2CValues} from "../calculator/calculatorC2C";

export const api = axios.create({
    baseURL: '/wp-json/trt-tms/v1/',
    headers: {"Accept": "*/*", 'Content-Type': 'application/json'},
    timeout: 30000,
});

export const getCountries = () => {
    return api.get("countries")
}

export const getQuote = (destinationCountryCode: string,
                         weight: number,
                         weightUnit: WeightUnit) => {
    return api.post("quote", {destinationCountryCode, weight, weightUnit})
}

export const getQuoteParcels = ({
                                    originZip,
                                    destinationCountryCode,
                                    destinationZip,
                                    weight,
                                    weightUnit,
                                    length,
                                    width,
                                    height
                                }: Omit<CalculatorC2CValues, 'originCountryCode'>) => {
    return api.post("parcel-quote", {
        originZip,
        destinationCountryCode,
        destinationZip,
        weight,
        weightUnit,
        length,
        width,
        height
    })
}

export const getLocations = (variables: { currentLocation: { lat: number, lng: number } }) => {
    return api.post("locations", variables)
}
